import { IntakeFormStep } from 'reducers/intakeForm/IntakeFormState';
import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getIntakeFormState = (state: RootState) => state.intakeForm;

export const getIntakeFormStep = createSelector(getIntakeFormState, intakeForm => intakeForm.step);

export const getIntakeFormLoading = createSelector(
    getIntakeFormState,
    intakeForm => intakeForm.loading
);

export const getIntakeFormProgress = createSelector(getIntakeFormState, intakeForm => {
    const totalSteps = Object.values(IntakeFormStep).length - 1;
    const currentStep = intakeForm.step;

    if (currentStep === IntakeFormStep.Success) {
        return 100;
    }

    if (currentStep === IntakeFormStep.CardOnFile) {
        return 90;
    }

    const progress = (currentStep / totalSteps) * 90;
    return Math.min(progress, 90);
});

export const getIntakeFormCustomer = createSelector(
    getIntakeFormState,
    intakeForm => intakeForm.customer
);

export const getIntakeFormPets = createSelector(getIntakeFormState, intakeForm => intakeForm.pets);
